import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon, BatteryChargingIcon, HomeIcon, PlugIcon, StarIcon, SunIcon, BoxIcon } from "lucide-react";
import { entryPaths, heroImage } from "../../data/home";
import { formatPrice } from "../../utils/currency";
const pathIcons: Record<(typeof entryPaths)[number]['id'], BoxIcon> = {
  plug: PlugIcon,
  home: HomeIcon,
  station: BatteryChargingIcon,
  solar: SunIcon
};
export function Hero() {
  return <section aria-label="Uitgelicht" data-id="element-134" data-mp="amgxhheuk1ek">
      <div className="relative overflow-hidden bg-surface" data-id="element-135" data-mp="5oxjmim29qn5">
        <img src={heroImage} alt="" className="absolute inset-0 h-full w-full object-cover object-[72%_center]" data-id="element-136" data-mp="5rjo29dnnq15" />

        <div className="relative mx-auto flex min-h-[560px] max-w-7xl items-center px-4 pb-28 pt-12 sm:px-6 lg:min-h-[660px] lg:px-8" data-id="element-137" data-mp="3rwosvxpsqle7">
          <div className="max-w-md rounded-2xl bg-white/95 p-7 shadow-[0_24px_60px_-28px_rgba(14,26,36,0.35)] backdrop-blur sm:p-9" data-id="element-138" data-mp="1v3c3opm4wpcb">
            <p className="flex items-center gap-2 text-xs font-semibold text-success" data-id="element-139" data-mp="1q63hmdxv815s">
              <span className="h-1.5 w-1.5 rounded-full bg-success" aria-hidden="true" data-id="element-140" data-mp="1muriqq6k284i" />
              Vóór 22:00 besteld
            </p>
            <h1 className="mt-3 text-[34px] font-extrabold leading-[1.05] tracking-tight text-ink sm:text-[42px]" data-id="element-141" data-mp="1cy6c60ew0oyk">
              Vandaag besteld, morgen in huis
            </h1>
            <p className="mt-4 text-[15px] leading-relaxed text-muted" data-id="element-142" data-mp="1hzc59zcgme8m">
              Thuisbatterijen, powerstations en zonnepanelen van A-merken. De laagste prijs per kWh, achteraf betalen en advies van
              echte technici.
            </p>
            <div className="mt-7 flex flex-wrap gap-3" data-id="element-143" data-mp="1vxslcgw7ph3f">
              <Link to="/shop/home-batteries" className="inline-flex h-12 items-center gap-2 rounded-lg bg-ink px-5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-ink-soft" data-id="element-144" data-mp="1vv6fcloyz9nb">
                Naar de thuisbatterijen
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-145" data-mp="2tcobggvoz8xy" />
              </Link>
              <Link to="/deals" className="inline-flex h-12 items-center rounded-lg border border-ink/15 bg-white px-5 text-sm font-semibold text-ink transition-colors duration-150 hover:border-ink" data-id="element-146" data-mp="338wuepqttkdr">
                Bekijk aanbiedingen
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Intent entry points */}
      <div className="relative z-10 mx-auto -mt-16 max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-147" data-mp="2p8cfw5ry2aq2">
        <ul className="grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-4" data-id="element-148" data-mp="2kb3u7v7l7ok2">
          {entryPaths.map(p => {
          const Icon = pathIcons[p.id];
          return <li key={p.id} data-id="element-149" data-mp="2ajg6o5e5irnv">
                <Link to={p.href} className="group flex h-full flex-col gap-3 rounded-2xl border border-line bg-white p-4 shadow-[0_16px_40px_-24px_rgba(14,26,36,0.3)] transition-[border-color,transform] duration-200 hover:-translate-y-0.5 hover:border-ink/25 sm:flex-row sm:items-start sm:p-5" data-id="element-150" data-mp="2akr8hzo1dpcc">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-volt text-ink" data-id="element-151" data-mp="1wkzrrr64xuun">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-152" data-mp="c1e2hs3q2kyo" />
                  </span>
                  <span className="flex min-w-0 flex-1 flex-col" data-id="element-153" data-mp="gzphsicsdnoa">
                    <span className="text-[15px] font-bold text-ink" data-id="element-154" data-mp="lzk7wjoqm98a">{p.title}</span>
                    <span className="mt-0.5 text-xs leading-snug text-muted" data-id="element-155" data-mp="q1f63fbdg6hu">{p.detail}</span>
                    <span className="mt-auto flex items-center justify-between pt-3 text-xs font-semibold text-ink" data-id="element-156" data-mp="3pgsnsxzwmz0d">
                      Vanaf {formatPrice(p.from)}
                      <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-157" data-mp="3ug55z5ftzhwm" />
                    </span>
                  </span>
                </Link>
              </li>;
        })}
        </ul>

        <div className="mt-6 flex justify-center" data-id="element-158" data-mp="36r45q5h5jd2f">
          <a href="#reviews" className="inline-flex items-center gap-3 rounded-full border border-line bg-white px-5 py-2.5 text-sm shadow-sm hover:border-ink/25" data-id="element-159" data-mp="36o88kjd4osf1">
            <span className="text-base font-bold text-ink" data-id="element-160" data-mp="2rocdoupwn9d8">4,8</span>
            <span className="flex" aria-hidden="true" data-id="element-161" data-mp="2mog8wt9dvdwm">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-162" data-mp="31d43aw7hthkz" />)}
            </span>
            <span className="hidden font-medium text-ink sm:inline" data-id="element-163" data-mp="2wme0nqqgbstz">6.200+ beoordelingen</span>
            <span className="border-l border-line pl-3 font-semibold text-ink underline underline-offset-2" data-id="element-164" data-mp="3adsj9wgg5s0i">Lees de reviews</span>
          </a>
        </div>
      </div>
    </section>;
}